import configService from './config';
import fetchApi from './fetchApi';
import guveryFetchApi from './guveryFetchApi';
import * as METHODS from './methods';
import TripDTO from '#root/models/TripDTO';

const guveryApi = configService.apiGuvery;

const list = async (offset: number = 0) => {
  const { response } = await guveryFetchApi({
    url: `${guveryApi}/trips?offset=${offset}`,
    options: METHODS.GET(),
    message: {
      success: 'Viajes obtenidos con exito.',
      error: 'No se puedo obtener los viajes.',
    },
  });

  return { ...response };
};

const select = async (tripId: string | number) => {
  const { response } = await guveryFetchApi({
    url: guveryApi + '/trips/select',
    options: METHODS.POST({
      trip_id: tripId,
    }),
    message: {
      success: 'Viaje seleccionado correctamente.',
      error: 'El viaje no existe o debe seleccionar un viaje vigente.',
    },
  });

  return { ...response };
};

const getCurrent = async () => {
  const { response } = await fetchApi({
    url: guveryApi + '/trips/current',
    options: METHODS.GET(),
    dataType: {},
    message: {
      success: 'Viaje obtenido con exito.',
      error: 'No se puedo obtener el viaje.',
    },
  });

  return { ...response };
};

const create = async (arg: TripDTO) => {
  const { response } = await fetchApi({
    url: guveryApi + '/trips/create',
    options: METHODS.POST({
      name: arg.nombre,
      departure_country: arg.departure_country,
      destination_country: arg.destination_country,
      city: arg.city,
      zipcode: arg.zipcode,
      accommodation_type: arg.accommodation_type,
      adults_qty: arg.adults_qty,
      arrive_date: arg.arrive_date,
      flag_receive: arg.flag_receive,
      flag_pickup: arg.flag_pickup,
      flag_no_travel: arg.flag_no_travel,
      delivery_place: arg.lugar_entrega,
      delivery_date: arg.fecha_entrega,
    }),
    dataType: {},
    message: {
      success: 'Viaje creado.',
      error: 'No se pudo crear el viaje.',
    },
  });

  return { ...response };
};

/**
 * Edicion de viaje por el viajero (G3).
 *
 * `payload` trae SOLO los campos que el usuario cambio y que estan en
 * `edit_policy.editable_fields`: las claves son las del API (`arrive_date`,
 * `delivery_date`, `delivery_place`, `name`, ...), no las de la columna.
 * Los flags viajan como '1' / '0' ('0' es un valor valido, no se filtra).
 *
 * Usa `guveryFetchApi` (no `fetchApi`): rrapi responde HTTP 200 tambien en
 * `response_failed`, y solo este wrapper lee `status`/`message` del envelope,
 * que es lo que permite mostrar el mensaje literal del server.
 */
const update = async (tripId: string | number, payload: Record<string, any>) => {
  const { response } = await guveryFetchApi({
    url: `${guveryApi}/trips/${tripId}`,
    options: METHODS.PUT(payload),
    message: {
      success: 'Viaje actualizado.',
      error: 'No se pudo actualizar el viaje.',
    },
  });

  return { ...response };
};

const tripService = {
  list,
  select,
  getCurrent,
  create,
  update,
};

export default tripService;
